// extracted by mini-css-extract-plugin
module.exports = {"boxNumber":"BoxNumber_boxNumber__36Lhk","text":"BoxNumber_text__3TYVq"};